import React from 'react';
import handlePlural from '../../../util/handlePlural';
import * as Util from '../../../util';
import PropTypes from 'prop-types';

ThreadSummary.propTypes = {
	threads: PropTypes.array,
	doIncludeCommunities: PropTypes.bool,
};

export default function ThreadSummary({ threads, doIncludeCommunities }) {
	const replies =
		threads && threads.reduce((a, b) => a + (b['children'] || 0), 0);

	const communityIds = threads && Util.groupBy(threads, 'communityId');

	const communitiesWithThreads = communityIds
		? Object.keys(communityIds).length
		: 0;

	return (
		<React.Fragment>
			{threads && (
				<span>
					{handlePlural('thought', threads.length)},{' '}
					{replies.toLocaleString()}{' '}
					{replies === 1 ? 'reply' : 'replies'}
					{doIncludeCommunities && (
						<span>
							{', '}
							{communitiesWithThreads.toLocaleString()}{' '}
							{communitiesWithThreads === 1
								? 'community'
								: 'communities'}
						</span>
					)}
				</span>
			)}
		</React.Fragment>
	);
}
